/* unplugin-vue-components disabled */import { render } from "./personal.vue?vue&type=template&id=197ab640&scoped=true&ts=true"
import script from "./personal.vue?vue&type=script&lang=ts"
export * from "./personal.vue?vue&type=script&lang=ts"

import "./personal.vue?vue&type=style&index=0&id=197ab640&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197ab640"]])

export default __exports__